import React from 'react';

import { DefaultComponentProps } from '../../types';

import { CardHeader } from '../CardHeader';

export const MailVerificationSent = ({ textConfig }: DefaultComponentProps) => {
  const { title, ingress, emoji, emojiLabel } = textConfig.mailVerificationSent;
  return (
    <>
      <CardHeader title={title} ingress={ingress} emoji={emoji} emojiLabel={emojiLabel} />
    </>
  );
};
